import {Box, Grid} from "@mui/material";
import DataSourceStatusButtons from "./DataSourceStatusButtons";
import commonStyles from "../commonStyles";

export default function DataSourceSummary({handle, trendsHandle, isTrendsOnly, label}) {
    const displayName = isTrendsOnly ? trendsHandle?.name : handle?.name;

    return (
        <Grid container columns={2}>
            <Grid item xs={4} md={1} sx={styles.nameContainer}>
                <Box component={'h4'}>{displayName}</Box>
            </Grid>
            <Grid item xs={4} md={1} sx={styles.statusContainer}>
                {isTrendsOnly ? (
                    <Box sx={styles.trendsOnlyLabel}>{label.TRENDS_READY_TO_MIGRATE}</Box>
                ) : (
                    <>
                        <Box sx={styles.statusLabel}>{label.VISIBILITY}</Box>
                        <DataSourceStatusButtons handle={handle} />
                    </>
                )}
            </Grid>
        </Grid>
    );
}

const styles = {
    nameContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    statusLabel: {
        ...commonStyles.labelMedium,
        padding: 1,
    },
    statusContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        paddingRight: 4
    },
    trendsOnlyLabel: {
        ...commonStyles.labelMedium,
        padding: 1,
        color: '#003300',
    },
};